  <template>
    <card-layout
      v-if="toplineData && toplineData['historical'] && dataMode === 'polling'"
      title="Historical View"
      :display-card="false"
      :split-header="true"
    >
      <template #header-right>
        <BFormSelect
          v-model="selectedHistory"
          :options="historicalOptions"
          class="mb-2 float-end"
        />
      </template>
      <TotalsHistoricalTimeline
            :name="selectedText"
            :value="selectedHistory"
      ></TotalsHistoricalTimeline>
    </card-layout>
</template>

<script setup>
  import { onMounted, computed, ref} from 'vue';
  import { storeToRefs } from 'pinia';
  import CardLayout from '../details/CardLayout.vue'
  import TotalsHistoricalTimeline from './TotalsHistoricalTimeline.vue';

  // Stores
  import { useToplinesStore } from '../../stores/toplines';

  const toplinesStore = useToplinesStore();

  // Store refs
  const {
      toplineData,
      dataMode,
  } = storeToRefs(toplinesStore);

  const historicalOptions = ref([
    {value: 'control_sim_timeseries', text: 'Democratic Control'},
    {value: 'total_category_seats_timeseries', text: 'Category Seats'},
    {value: 'total_pred_margin_seats_timeseries', text: 'Margin Seats'},
    {value: 'total_win_prob_seats_timeseries', text: 'Win Probability Seats'},
  ]);

  const selectedHistory = ref('control_sim_timeseries');

  const selectedText = computed(() => {
    if (!selectedHistory.value) {
      return ''
    }

    const selectedOption = historicalOptions.value.find(option =>
      option.value === selectedHistory.value
    )
    return selectedOption ? selectedOption.text : ''
  });


  onMounted(() => {
    console.log('TotalsHistorical Component mounted.');
  });

</script>
<style>
</style>